import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import { getMessages } from "@redux/modules/value/messages/messages.selectors";
import { clearMessageById } from "@redux/modules/value/messages/messages.utils";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { MessageComponent } from "./messages.component";

type Props = {
    messageid: string;
    className?: string;
};

const Messages = ({ messageid, className }: Props) => {
    const { t } = useGranite();
    const messages = useSelector(getMessages);
    const message = messages.find(message => message.id === messageid);
    const messageList = [];

    if (!message) {
        return <Fragment />;
    }

    if (message.id === "api-message") {
        const apiMsgs = message.text.map((m: any) => ({
            id: message.id,
            status:
                m.type === "ERROR"
                    ? "danger"
                    : m.type === "success"
                    ? "success"
                    : "warning",
            text: t(`apiMessages.title.${m.code}`, ...m.parameters),
            postFix: m.postFix,
            dismissible: m.type !== "ERROR",
        }));
        messageList.push(...apiMsgs);
    } else if (message.id === "sales-incentive") {
        const salesIncentiveMsgs = message.text.map((m: string) => ({
            id: message.id,
            status: message.status,
            text: m,
            dismissible: message.dismissible,
        }));
        messageList.push(...salesIncentiveMsgs);
    } else {
        messageList.push(message);
    }

    return (
        <Fragment>
            {messageList.map(msg => (
                <MessageComponent
                    key={msg.id}
                    message={msg}
                    clearById={clearMessageById}
                    className={className}
                />
            ))}
        </Fragment>
    );
};

export { Messages };
